import React, {useCallback, useState } from "react";
import {IndicatorMap, IndicatorsContext, IndicatorsContextProps} from "./indicators-context.ts";
import IndicatorValueDto from "@/models/interfaces/dtos/indicators/indicator-value-dto.ts";

const IndicatorsContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [typeIndicator, setTypeIndicator] = useState<string>("SHAB");

    const [projectsIndicators, setProjectsIndicators] = useState<IndicatorMap>({});

    const setIndicatorsForProject = useCallback((projectId: string, data: IndicatorValueDto[]) => {
        setProjectsIndicators((prev) => ({
            ...prev,
            [projectId]: data,
        }));
    }, []);

    const indicatorsProps: IndicatorsContextProps = {
        typeIndicator,
        setTypeIndicator,
        projectsIndicators,
        setIndicatorsForProject
    }
    
    return (
        <IndicatorsContext.Provider value={indicatorsProps}>
            {children}
        </IndicatorsContext.Provider>
    );
}

export default IndicatorsContextProvider;